mutation CompanyBusinessUnitDelete($input: CompanyBusinesUnitDeleteInput!) {
  companyBusinesUnitDelete(input: $input) {
    deletedEntities {
      companyBusinessUnitsDeleted {
        id
        rowTimestamp
      }
      _isCompanyTokenRefreshRequired
      _companyRefreshId
    }
  }
}